import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import edit from "../../../../Assets/edit.svg";
import del from "../../../../Assets/Box.svg";
import ExcelIcon from "../../../../Assets/ExcelIcon.svg";
import "../button.css";
import io from 'socket.io-client';



const socket = io('https://policydekhoo-backend.onrender.com');

const BikeInsurance = ({exportToExcel,setData}) => {
  // const top100Films = [
  //   { label: "The Shawshank Redemption", year: 1994 },
  //   { label: "The Godfather", year: 1972 },
  //   { label: "The Godfather: Part II", year: 1974 },
  //   { label: "The Dark Knight", year: 2008 },
  //   { label: "12 Angry Men", year: 1957 },
  //   { label: "Schindler's List", year: 1993 },
  //   { label: "Pulp Fiction", year: 1994 },
  // ];
  const data=JSON.parse(localStorage.getItem("userData")).Permissions
  const [permissionsList,setpermissionsList]=useState([])
 


  useEffect(() => {
  if(data!==null)
    {
  setpermissionsList(data.split(","))
    }
 
    socket.on('dataUpdatedBike1', (updatedData) => {
      setData(updatedData)
        setBikeInsurancedata(updatedData);
    }); 
    socket.on('deleteDataBike1', (Data) => {
        setData(Data)
        setBikeInsurancedata(Data);
    });
    return () => {
        socket.disconnect();
    };
}, []);

  const currencies = ["value1", "value2", "value3"];

  const rowsPerPageOptions = [5, 10, 25]; // Rows per page options

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [editcheck, seteditcheck] = React.useState(false);
    const [idselected, setidselected] = useState();

    const editdata = (e) => {
      // console.log(e);
      seteditcheck(false);
    };

    const [tableName, settablename] = useState("bike_insurance");

    // useEffect(() => {
    //   console.log("Id to be deleted is : =======", idselected);
    // }, [idselected]);

    const handleDelete = async (id) => {
      try {
        // Store the ID of the row when delete button is clicked
        setidselected(id);
        // console.log("Id to be deleted is : =======", id);

        // Construct the URL with the tableName and idselected
        const url = `https://policydekhoo-backend.onrender.com/Removedata?tableName=${tableName}&id=${id}`;

        // Make a DELETE request to the URL
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to delete data");
        }

        // Optionally, you can handle the response here
        const responseData = await response.json();
        const temp=[...BikeInsurancedata]
        let ind=""
        temp.map((val,index)=>{
          if(val.id===id){
            ind=index;
            console.log(val,index)
          }
        })
        temp.splice(ind,1);
        console.log(temp,"jaiiii");
        console.log("Delete response:", responseData);
        setBikeInsurancedata(temp)
        setData(temp)
      socket.emit('deleteDataBike', temp);


        console.log("Delete response:", responseData);

        // Refresh the data after deletion
        // Call the function that fetches data again
        // getCarInsurancedata();
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    };

    const addvalues = (e) => {
      setdata2({ ...data2, [e.target.name]: e.target.value });
    };

    const [data2, setdata2] = useState({});

    console.log("data2", data2);

    const UpdateBikeInsurance = async (id) => {
      // setidselected(id);
      console.log("Id to be updated is : =======", id);
      // e.preventDefault();

      try {
        // setidselected(id); // Set the ID first
        console.log(
          "===============data to be updated and id",
          data2,
          id,
          tableName
        );
        const response = await fetch(
          `https://policydekhoo-backend.onrender.com/Updatedata?tableName=${tableName}&id=${id}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data2),
          }
        );

        if (response.ok) {
          const temp=[...BikeInsurancedata]
          let ind=""
          temp.map((val,index)=>{
            if(val.id===id)
              {
                ind=index
              }
          })
          const temp1={...temp[ind]}
          console.log(temp1,"[][][][][][[[[")    
          Object.keys(data2).map((k1)=>(
            temp1[k1]=data2[k1]
          )) 
          temp[ind]=(temp1);
          setBikeInsurancedata(temp) 
          setData(temp)
        socket.emit('editDataBike', temp);

          console.log("Data updated successfully");
        } else {
          console.error("Failed to update data");
        }
      } 
      catch (error) {
        console.error("Error:", error);
      }
      editdata();
    };

  

    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          {row.map((val, index) =>
            index <= 3 ? (
              editcheck ? (
                <TableCell align="left">
                  <TextField
                    id="outlined-size-small"
                    defaultValue={val}
                    size="small"
                    name={
                      index === 1
                        ? "Fullname"
                        : index === 2
                        ? "Email"
                        : index === 3
                        ? "Contact"
                        : ""
                    }
                  />
                </TableCell>
              ) : (
                <TableCell align="left">{val}</TableCell>
              )
            ) : (
              ""
            )
          )}
          <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>
            {row[4] === "pending" ? (
              <label
                className="p-1 px-2 mx-1 rounded  pendng-bg"
                htmlFor="pending"
              >
                <b> Pending</b>
              </label>
            ) : (
              ""
            )}
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[4] === "accepted" ? "accepted-bg" : "border-accepted"
              }   `}
              htmlFor="Accepted"
            >
              <b>Accepted</b>
            </label>
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[4] === "denied" ? " denied-bg" : "border-denied"
              }`}
              htmlFor="Denied"
            >
              <b>Denied</b>
            </label>
          </TableCell>

          { permissionsList.includes("edit")||permissionsList.includes("delete")?
          <TableCell
            className="text-left"
            sx={{ minWidth: 100, whiteSpace: "nowrap" }}
          >
             { permissionsList.includes("edit")?
            <label className="me-1">
              <img
                src={edit}
                alt=""
                onClick={() => {
                  seteditcheck(true);
                }}
              />
            </label>
            :""}
             { permissionsList.includes("delete")?
            <label className="me-1">
              <img src={del} alt="" onClick={() => handleDelete(row[0])} />
            </label>
            :""}
          </TableCell>

          :""}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                {/* <Typography variant="h6" gutterBottom component="div">
                  History
                </Typography> */}
                <Table size="medium" aria-label="purchases">
                  <TableBody className="text-left">
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Registration no - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].rgno}
                            size="small"
                            value={data2.Registration_No}
                            onChange={addvalues}
                            name="Registration_No"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Registration no - </b>
                          {row[5].rgno}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Manufacturing - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].manufacturing}
                            size="small"
                            value={data2.Manufacturer}
                            onChange={addvalues}
                            name="Manufacturer"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Manufacturing - </b>
                          {row[5].manufacturing}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Model - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].model}
                            size="model"
                            value={data2.Model}
                            onChange={addvalues}
                            name="Model"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Model - </b>
                          {row[5].model}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Do you have Precious Policy - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].previousInsurer}
                            size="small"
                            value={data2.Previous_Insurer}
                            onChange={addvalues}
                            name="Previous_Insurer"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Do you have Precious Policy - </b>
                          {row[5].doyouhavePreciousPolicy}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Policy Expiry Date - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].policyExpiryDate}
                            size="small"
                            value={data2.Policy_Expiry_Date}
                            onChange={addvalues}
                            name="Policy_Expiry_Date"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Policy Expiry Date - </b>
                          {row[5].policyExpiryDate}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Year of manufacturing - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].yearOfManufacturing}
                            value={data2.Year_Of_Manufacturing}
                            onChange={addvalues}
                            name="Year_Of_Manufacturing"
                            size="small"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Year of manufacturing - </b>
                          {row[5].yearOfManufacturing}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Any Claims This year - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].anyClaimsThisYearr}
                            size="small"
                            value={data2.Any_Claims_This_Year}
                            onChange={addvalues}
                            name="Any_Claims_This_Year"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Any Claims This year - </b>
                          {row[5].anyClaimsThisYear}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Last Year NCB - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].lastYearNCB}
                            value={data2.Last_Year_NCB}
                            onChange={addvalues}
                            name="Last_Year_NCB"
                            size="small"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Last Year NCB - </b>
                          {row[5].lastYearNCB}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Previous Insurer - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].previousInsurer}
                            size="small"
                            value={data2.Previous_Insurer}
                            onChange={addvalues}
                            name="Previous_Insurer"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Previous Insurer - </b>
                          {row[5].previousInsurer}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell>
                          <button
                            className="mt-5 accepted-bg px-3 p-1 rounded border-0 "
                            onClick={() => {
                              editdata();
                              UpdateBikeInsurance(row[0]);
                            }}
                          >
                            save
                          </button>
                        </TableCell>
                      ) : (
                        <TableCell></TableCell>
                      )}
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }









console.log(permissionsList,"ffffff");



  const [BikeInsurancedata, setBikeInsurancedata] = useState(
    [
    // {
    //   id: 1,
    //   Registration_No: "XYZ0000",
    //   Manufacturer: "Tesla",
    //   Model: "XXKKK",
    //   Previous_Year_Policy: "Yes",
    //   Policy_Expiry_Date: "2020-04-16T18:30:00.000Z",
    //   Year_Of_Manufacturing: "2011",
    //   Previous_Insurer: "SBI",
    //   Any_Claims_This_Year: "No",
    //   Last_Year_NCB: null,
    //   First_Name: "Yash",
    //   Last_Name: "Sukhlani",
    //   Email_Address: "Yash@121",
    //   Contact_Number: "5646546534",
    // },
    // {
    //   id: 2,
    //   Registration_No: "BKJBHK000",
    //   Manufacturer: "tata",
    //   Model: "Creata 11",
    //   Previous_Year_Policy: "No",
    //   Policy_Expiry_Date: null,
    //   Year_Of_Manufacturing: null,
    //   Previous_Insurer: null,
    //   Any_Claims_This_Year: null,
    //   Last_Year_NCB: null,
    //   First_Name: "Rahul",
    //   Last_Name: "Sharma",
    //   Email_Address: "Rahul@mnnj",
    //   Contact_Number: "16521465",
    // },
    // {
    //   id: 3,
    //   Registration_No: "fghfghh",
    //   Manufacturer: "KAWASAKI",
    //   Model: "",
    //   Previous_Year_Policy: "Yes",
    //   Policy_Expiry_Date: "2020-04-25T18:30:00.000Z",
    //   Year_Of_Manufacturing: "2019",
    //   Previous_Insurer: "Navi General Insurance Limited",
    //   Any_Claims_This_Year: "Yes",
    //   Last_Year_NCB: null,
    //   First_Name: "yyhjksadhfaf",
    //   Last_Name: "frjgoikfghj",
    //   Email_Address: "bnjbjhkvbjhkv@",
    //   Contact_Number: "4654654654",
    // },
    // {
    //   id: 4,
    //   Registration_No: "ghfjghj",
    //   Manufacturer: "HEROMOTOCORP",
    //   Model: "SPLENDOR PLUS",
    //   Previous_Year_Policy: "No",
    //   Policy_Expiry_Date: null,
    //   Year_Of_Manufacturing: null,
    //   Previous_Insurer: null,
    //   Any_Claims_This_Year: null,
    //   Last_Year_NCB: null,
    //   First_Name: "yash",
    //   Last_Name: "jiuoihs",
    //   Email_Address: "dfghfdghfgh@",
    //   Contact_Number: "4654654654",
    // },
  ]
);

  const [tableName, settablename] = useState("bike_insurance");

  useEffect(() => {
    const getBikeInsurancedata = async () => {
      const url = `https://policydekhoo-backend.onrender.com/GetAllData?tableName=${tableName}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then((response => response.json()))
        if(response.msg!=="Error Fetching  data")
          {

            setBikeInsurancedata(response);
            setData(response)
        }

        // const data = await response.json();
        // console.log("Groups:", data);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    getBikeInsurancedata();
  }, []);
  console.log(BikeInsurancedata,"[][][][][]")

  const rows = BikeInsurancedata.map((data) => [
    data.id,
    `${data.First_Name} ${data.Last_Name}`,
    data.Email_Address,
    data.Contact_Number,
    data.status,
    {
      rgno: data.Registration_No,
      manufacturing: data.Manufacturer,
      model: data.Model,
      Previous_Year_Policy: data.Previous_Year_Policy,
      policyExpiryDate: data.Policy_Expiry_Date,
      yearOfManufacturing: data.Year_Of_Manufacturing,
      anyClaimsThisYear: data.Any_Claims_This_Year,
      lastYearNCB: data.Last_Year_NCB,
      previousInsurer: data.Previous_Insurer,
    },
  ]);

  const Column = ["Unique ID", "Name", "Email", "Contact"];

  return (
    <div className="fade">
      <h3>Bike Insurance</h3>
      <div className="row ">
        {/* <div className="col-12 my-sm-1 my-2 col-sm-4 col-md-3">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
           options={top100Films}
            // sx={{ width: 280 }}
            renderInput={(params) => <TextField {...params} label="Search" />}
          />
        </div> */}
        {/* <div className="col-12 my-sm-1 my-2 col-sm-3 col-md-2 "> */}
          <div className="text-end mx-2">
                    
                    <img src={ExcelIcon} width={"30rem"} style={{cursor:"pointer"}} className="me-4" alt="excelIcon" onClick={exportToExcel} />
          {/* <TextField
            id="outlined-select-currency"
            select
            fullWidth
            label="Status"
            defaultValue={""}
          >
            {currencies.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}
        </div>
      </div>
      <div className="row m-2">
        <Paper sx={{ overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: "60vh" }}>
            <Table aria-label="collapsible table" id="my-table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  {Column.map((val, index) => (
                    <TableCell
                      className="text-left"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <b>{val}</b>
                    </TableCell>
                  ))}
                  <TableCell sx={{ minWidth: 140 }} className="text-left">
                    <b>Status</b>
                  </TableCell>
                  { permissionsList.includes("edit")||permissionsList.includes("delete")?
                  <TableCell className="text-left">
                    <b>Actions</b>
                  </TableCell>:""
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <Row key={index} row={row} />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
};

export default BikeInsurance;
